import styled from 'styled-components'
import { Icon } from 'ui/styled'

export const MediaRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.backgroundStrong};
  box-shadow: 0 18px 34px ${p => p.theme.palette.colors.shadowStrong};
`;

export const BackButtonRow = styled.div.attrs({})`
  padding-bottom: 12px;
`;

export const BackButton = styled.button.attrs({})`
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${p => p.theme.palette.colors.muted};
  font-family: Gilroy;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: ${p => p.theme.palette.colors.text};
  }

  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.blue.main};
    outline-offset: 4px;
    border-radius: 8px;
  }

  &:active {
    transform: translateX(-1px);
  }
`;

export const BackButtonIcon = styled(Icon).attrs({})`
  color: ${p => p.theme.palette.colors.subdued};
  font-size: 13px;
  margin: 0;
`;

export const MediaBody = styled.div.attrs({})`
  padding: 24px;

  @media(max-width: 767px){
    padding: 18px;
  }
`;

export const AudioShell = styled.div.attrs({})`
  display: grid;
  grid-template-columns: minmax(0, 260px) minmax(0, 1fr);
  gap: 20px;
  align-items: center;

  @media(max-width: 767px){
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const AudioPoster = styled.img.attrs({})`
  width: 100%;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
`;

export const AudioTitle = styled.div.attrs({})`
  margin-bottom: 14px;
  font-family: Gilroy;
  font-size: 22px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const AudioElement = styled.audio.attrs({})`
  width: 100%;
`;

export const PdfShell = styled.div.attrs({})`
  display: flex;
  justify-content: center;
`;

export const ArticleImage = styled.img.attrs({})`
  width: 100%;
  max-height: 540px;
  object-fit: cover;
  display: block;
`;

export const FallbackPanel = styled.div.attrs({})`
  min-height: 360px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.surfaceSoft};
  color: ${p => p.theme.palette.colors.muted};
  font-family: Lato;
  font-size: 15px;
`;
